var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimecardStatsChevron(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 5,
    viewBox: "0 0 9 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.195262 0.197669C-0.0650872 0.458018 -0.0650875 0.880128 0.195262 1.14048L2.98534 3.92783C3.7665 4.70823 5.0323 4.70792 5.81308 3.92714L8.60215 1.13807C8.8625 0.877721 8.8625 0.455612 8.60215 0.195262C8.3418 -0.0650881 7.91969 -0.0650868 7.65934 0.195262L5.10461 2.74999C4.71408 3.14052 4.08092 3.14052 3.69039 2.74999L1.13807 0.197668C0.877722 -0.0626807 0.455612 -0.0626807 0.195262 0.197669Z",
    fill: "#3C5873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimecardStatsChevron);
export default __webpack_public_path__ + "static/media/timecard-stats-chevron.f0d902d2.svg";
export { ForwardRef as ReactComponent };